import { Link } from "react-router-dom";
import { SignInForm } from "@/components/auth/sign-in-form";

export function SignInPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-foreground">career-ops</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Sign in to your pipeline
          </p>
        </div>

        <div className="rounded-lg border border-border bg-card p-6">
          <SignInForm />
        </div>

        <p className="mt-4 text-center text-sm text-muted-foreground">
          Don&apos;t have an account?{" "}
          <Link
            to="/signup"
            className="font-medium text-brand hover:underline"
          >
            Sign up
          </Link>
        </p>
      </div>
    </main>
  );
}